import React, { useState, useEffect } from "react";
import { TextField } from "@mui/material";

export default function MinuteInput({ value, onChange, label = "Tempo (seg)" }) {
    const [internalValue, setInternalValue] = useState(String(value));

    useEffect(() => {
        setInternalValue(String(value));
    }, [value]);

    const handleChange = (e) => {
        setInternalValue(e.target.value);
    };

    const handleBlur = () => {
        let newVal = Number(internalValue);

        if (isNaN(newVal) || newVal < 30) {
            newVal = 30;
        }

        setInternalValue(String(newVal));
        onChange(newVal);
    };

    return (
        <TextField
            label={label}
            inputMode="numeric"
            value={internalValue}
            onChange={handleChange}
            onBlur={handleBlur}
            size="small"
            sx={{
                width: {
                    xs: 100, sm: 100, md: 100, lg: 100, xl: 180,
                },
                "& .MuiInputBase-input": {
                    fontSize: {
                        xs: "0.7rem", sm: "0.8rem", md: "0.9rem", lg: "1rem", xl: "2rem",
                    },
                    height: {
                        xs: 35, sm: 35, md: 40, lg: 40, xl: 80,
                    },
                    padding: "0 14px",
                    boxSizing: "border-box",
                },
                "& .MuiInputLabel-root": {
                    fontSize: {
                        xs: "0.7rem", sm: "0.8rem", md: "0.9rem", lg: "1rem", xl: "2rem",
                    },
                },
            }}
        />
    );
}
